import React, { Component } from 'react';
import { withLanguageContext } from '../../../utils/LanguageContext';
import { HubHero } from '../../templates';
import './styles.css';

/**
 * The hero section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class HubHeroView extends Component {

	render () {
		const {
			topHeading,
			heading,
			subheading,
		} = this.props.content.hubLandingPage.hero;

		return (
			<HubHero
				{...{
					heading,
					subheading,
					topHeading,
				}}
			/>
		);
	}

}

export default withLanguageContext(HubHeroView);



// WEBPACK FOOTER //
// ./src/components/views/HubHeroView/HubHeroView.js